import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService } from 'src/app/services/storage/storage.service';
import { DownloadArquivoService } from 'src/app/services/download-arquivo/download-arquivo-service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-download-arquivo',
  templateUrl: './download-arquivo.component.html',
  styleUrls: ['./download-arquivo.component.scss'],
})
export class DownloadArquivoComponent implements OnInit, OnDestroy {
  form = new FormGroup({
    clienteSelecionado: new FormControl(null, Validators.required),
    operacaoSelecionada: new FormControl(null, Validators.required),
  });

  file: File | null = null;
  usuario: any;
  public fileName: string = '';
  public listaClientes: any[] = [];
  public listaOperacao: any[] = [];
  public listaArquivos: { nome: string, dataCriacao: string }[] = [];
  public carregando: boolean = false;

  private onDestroy = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<DownloadArquivoComponent>,
    private svc: DownloadArquivoService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.usuario = StorageService.getPerfilUsuario();

    this.svc.getClientesAtivos().subscribe((res) => {
      if (res) this.listaClientes = res;
    });
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  get clienteSelecionado() {
    return this.form.get('clienteSelecionado')?.value;
  }

  get operacaoSelecionada() {
    return this.form.get('operacaoSelecionada')?.value;
  }

  selecionarCliente() {
    const clienteId = this.clienteSelecionado;
    if (clienteId) {
      this.svc.getOperacao(clienteId).subscribe((operacoes) => {
        if (operacoes) {
          this.listaOperacao = operacoes;
          this.form.get('operacaoSelecionada')?.updateValueAndValidity();
        }
      });
    }
  }

  listaDownload() {
    const operacaoSelecionada = this.operacaoSelecionada;
    const operacaoInfo = this.listaOperacao.find(op => op.operacao === operacaoSelecionada);

    if (!operacaoInfo) {
      this.openSnackBar('Operação não encontrada.', 'Fechar', 3000, 'warning-snackbar');
      return;
    }

    const input = {
      ipServidor: operacaoInfo.ipServidor,
      diretorio: operacaoInfo.diretorio
    };

    this.carregando = true;

    this.svc.pesquisarArquivos(input).subscribe({
      next: (arquivos: { nome: string; dataCriacao: string }[]) => {
        this.listaArquivos = arquivos || [];
        this.carregando = false;
        console.log(this.listaArquivos)
      },
      error: (err) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar arquivos.', 'Fechar', 3000, 'danger-snackbar');
        this.carregando = false;
      }
    });
  }

  baixarArquivo(nomeArquivo: string) {
    const operacaoInfo = this.listaOperacao.find(op => op.operacao === this.operacaoSelecionada);
  
    if (!operacaoInfo) {
      this.openSnackBar('Operação inválida.', 'Fechar', 3000, 'warning-snackbar');
      return;
    }
  
    const ip = operacaoInfo.ipServidor;
    const dir = operacaoInfo.diretorio;
  
    this.svc.downloadArquivo({ ipServidor: ip, diretorio: dir, nomeArquivo }).subscribe({
      next: (response: any) => {
        if (!response?.fileContents) {
          this.openSnackBar('Arquivo inválido ou vazio.', 'Fechar', 3000, 'danger-snackbar');
          return;
        }
  
        const byteCharacters = atob(response.fileContents);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: response.contentType });
  
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = response.fileDownloadName;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('Erro ao baixar o arquivo', err);
        this.openSnackBar('Erro ao baixar o arquivo.', 'Fechar', 3000, 'danger-snackbar');
      }
    });
  }
  
  
 
  limparCampos() {
    this.form.reset();
    this.listaOperacao = [];
    this.listaArquivos = [];
  }

  private openSnackBar(message: string, action: string, duration: number, panelClass?: string): void {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
